import { TypedRootState } from '../types';

export const selectBcdplusPrevState = (state: TypedRootState) => state.bcdplusPrevState;
